import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { Observable, timer } from 'rxjs';

@Pipe({
    name: 'countdown'
})
export class CountdownPipe implements PipeTransform {



    /**
     * @param futureDate    should be in a valid Date Time format
     *                      e.g. YYYY-MM-DDTHH:mm:ss.msz
     *                      e.g. 2021-06-04T17:27:10.740z
     */
    // public transform(futureDate: any): Observable<string> {
    //     /**
    //      * Initial check to see if time remaining is in the future
    //      * If not, don't bother creating an observable
    //      */
    //     console.log(futureDate)
    //     const formatted: any = moment.utc(futureDate * 1000).format('HH:mm:ss');
    //     console.log(formatted)
    //     return formatted;

    // }

    transform(futureDate: any): unknown {
        const formatted: any = moment.utc(futureDate * 1000).format('mm:ss');
        return formatted;
    }
}